   <template>
  <footer>
    <div class="footer display-flex">
      <div class="footer-serve-div m-r-150">
        <h3>服务</h3>
        <dd>
          <a href="#">电子礼品卡</a>
        </dd>
        <dd>
          <a href="#">企业团购</a>
        </dd>
        <dd>
          <a href="#">订阅电子邮箱</a>
        </dd>
        <dd>
          <a href="#">网站反馈</a>
        </dd>
      </div>
      <div class="footer-help-div m-r-149">
        <h3>获得帮助</h3>
        <dd>
          <a href="#">订单状态</a>
        </dd>
        <dd>
          <a href="#">配送方式</a>
        </dd>
        <dd>
          <a href="#">退换货</a>
        </dd>
        <dd>
          <a href="#">付款方式</a>
        </dd>
        <dd>
          <a href="#">联系我们</a>
        </dd>
      </div>
      <div class="footer-us-div">
        <h3>关注我们</h3>
        <div class="footer-img-div display-flex m-t-3">
          <div class="footer-us-public">
            <img class="m-b-16" src="../../assets/img/gongzhonghao-img.png" />
            <p>公众号</p>
          </div>
          <div class="footer-us-weibo m-l-28">
            <img class="m-b-16" src="../../assets/img/weibo-img.png" />
            <p>新浪微博</p>
          </div>
        </div>
      </div>
    </div>
    <div class="beian" style="text-align: center;">
      <p>
        ©2016-2020 www.alidingzhi.com&nbsp;All Rights Reserved. &nbsp;&nbsp;&nbsp;&nbsp;杭州持码网络科技有限公司 版权所有&nbsp;&nbsp;
        <a
          href="http://www.beian.miit.gov.cn"
        >浙ICP备16043117号-2</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "cell",
  data: function() {
    return {
      msg: "我是多页面 的 cell  页面"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.ban {
  width: 1200px;
  margin: 0 auto;
}
footer {
  width: 100%;
  height: 424px;
  background: rgba(38, 38, 38, 1);
  .footer {
    width: 100%;
    height: 293px;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(255, 255, 255, 1);
    h3 {
      font-size: 16px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      width: 100%;
      text-align: center;
      margin-bottom: 30px;
      margin-top: 17px;
    }
    dd {
      margin-bottom: 15px;
      a {
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        width: 100%;
        text-align: center;
      }
    }
    .footer-serve-div,
    .footer-help-div,
    .footer-us-div {
      text-align: center;
    }
    .footer-img-div {
      justify-content: space-between;
    }
    .footer-img-div p {
      font-size: 14px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
    }
  }
  .beian {
    margin-top: 46px;
    p {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
      a {
        color: #337ab7;
      }
    }
  }
}

dd {
  margin-left: 0;
}
</style>
   
   
   


// WEBPACK FOOTER //
// src/components/common/bottom.vue